import { Tag } from '@/ui';
import styled from 'styled-components';
import { pickThemeColor } from '@/theme';

export const StyledBlock = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 2rem;
`;

export const StyledItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const StyledListWrap = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export const StyledTag = styled(Tag)`
  border: none;
  align-self: start;
  background-color: ${pickThemeColor('GREY_BRIGHT')};
`;
